var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterDivider2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "733px",
    height: "42px",
    viewBox: "0 0 733 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(127, 0, 0)",
    d: "M726.455,22.932 L402.437,22.932 L385.116,40.373 C384.677,40.815 384.084,41.062 383.465,41.061 L349.160,41.059 C348.541,41.058 347.947,40.812 347.509,40.370 L330.191,22.932 L6.542,22.932 L0.563,16.969 C0.782,16.748 1.079,16.625 1.388,16.624 L332.468,16.624 L347.509,1.479 C347.947,1.037 348.541,0.790 349.160,0.790 L383.465,0.787 C384.084,0.787 384.677,1.034 385.116,1.476 L400.160,16.624 L731.609,16.624 C731.918,16.625 732.215,16.748 732.435,16.969 L726.455,22.932 ZM381.975,5.987 L350.650,5.990 L335.819,20.925 L350.650,35.858 L381.975,35.862 L396.809,20.925 L381.975,5.987 ZM355.034,31.652 L343.956,20.667 L355.035,9.681 L378.433,9.679 L389.514,20.667 L378.433,31.655 L355.034,31.652 ZM412.973,11.655 L401.892,11.667 L392.973,2.679 L611.372,2.681 L622.450,11.667 L611.372,11.652 L412.973,11.655 ZM319.433,11.655 L121.034,11.652 L109.956,11.667 L121.035,2.681 L339.434,2.679 L330.514,11.667 L319.433,11.655 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterDivider2);
export default __webpack_public_path__ + "static/media/center_divider_2.1dd26705e5b1457d211c74a543cfd88f.svg";
export { ForwardRef as ReactComponent };